import React from 'react'

import { connect } from "react-redux"

import { Redirect } from 'react-router-dom'

import Routes from '../routing/Routes'

// if the component is accessing the store then we must use withRouter Higher order component to inject in the routing functionality
// without withRouter and with connect routing doesn't work
// withRouter not needed if connect is not used here
import { withRouter } from 'react-router'

import { Messages } from 'primereact/messages'

import '../css/main.css'

class Main extends React.Component {
  constructor(props) {
    super(props)

    // create references to messages list
    this.messagesList = React.createRef()
  }

/*
  componentDidUpdate(prevProps) {
    let previousHasSessionTimedOut = prevProps.auth.hasSessionTimedOut
    let hasSessionTimedOut = this.props.auth.hasSessionTimedOut
    if (previousHasSessionTimedOut === false && hasSessionTimedOut === true) {
      let sessionError = <ul><li>Session has expired. Please login again.</li></ul>

      // set sticky to true so the user must close otherwise it will close automatically
      this.messagesList.current.show({ sticky: true, severity: 'error', summary: '', detail: sessionError })
    }
  }*/

  

  render() {
    return (
      <div className="main-content p-col-12 p-md-10">
        <Messages className={"response-message"} ref={this.messagesList}></Messages>
        <div className="">
          {this.props.auth.hasSessionTimedOut === true && this.props.location.pathname !== '/login' && <Redirect to='/login' />}
          {this.props.auth.hasCheckedForUserToken && <Routes />}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  let { auth } = state
  return { auth }
}

export default withRouter(connect(mapStateToProps)(Main))


// WEBPACK FOOTER //
// ./src/container/Main.js